import { Button } from "src/components/ui/button";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomInput from "../CustomInput";
import { DialogClose } from "../ui/dialog";
import CustomSelect from "../CustomSelect";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createEntity, editEntity, getStaff } from "src/api/settings";
import { showSuccessToast } from "src/lib/utils";
import { usePortalContext } from "src/context/PortalContext";
import PermissionWrapper from "../PermissionWrapper";

const validationSchema = Yup.object().shape({
	name: Yup.string().required("This field is required"),
	address: Yup.string().required("This field is required"),
	type: Yup.string().required("This field is required"),
	manager_id: Yup.string(),
});

const CreateWarehouse = ({ entity }) => {
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const initialValues = {
		...(entity && { uuid: entity?.uuid }),
		name: entity?.name ?? "",
		address: entity?.address ?? "",
		manager_id: entity?.manager_id ?? "",
		type: entity?.type ?? "",
	};

	const { mutate, isLoading } = useMutation(entity ? editEntity : createEntity, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["entities"]);
			closePortal();
		},
	});

	const { data } = useQuery({
		queryKey: ["teams", "active"],
		queryFn: () => getStaff("active")({ page: 1, limit: 50 }),
		suspense: true,
	});

	const staff = data?.data ?? [];

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ handleSubmit, values, handleChange, setFieldValue }) => (
				<form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-gap-6">
					<CustomInput name="name" value={values.name} onChange={handleChange} label="Store Name" placeholder="Store Name" />
					<CustomInput name="address" value={values.address} onChange={handleChange} label="Store Address" placeholder="Store Address" />
					<CustomSelect
						name="type"
						label="Type"
						placeholder="Select Type"
						value={values.type}
						onChange={(value) => setFieldValue("type", value)}
						options={[
							{ label: "Store", value: "store" },
							{ label: "Warehouse", value: "warehouse" },
						]}
					/>
					<PermissionWrapper permission={[["assign_warehouse_manager"], ["change_warehouse_manager"]]}>
						<CustomSelect
							name="manager_id"
							label="Storefront Manager"
							placeholder="Storefront Manager"
							value={values.manager_id}
							onChange={(value) => setFieldValue("manager_id", value)}
							options={staff?.map(({ id, first_name, last_name }) => ({ value: id, label: `${first_name} ${last_name}` }))}
						/>
					</PermissionWrapper>
					<div className="tw-flex tw-items-center tw-justify-end tw-gap-4 tw-mt-3">
						<DialogClose asChild>
							<Button type="button" variant="ghost">
								Cancel
							</Button>
						</DialogClose>
						<Button disabled={isLoading}>Save</Button>
					</div>
				</form>
			)}
		</Formik>
	);
};

export default CreateWarehouse;
